import request from '@/utils/request' //引入封装好的 axios 请求

//政策指南 列表
export function getGuideList(data = {}) { 
    return request({
        url: '/api/v1/news_policy/news_policy_list',
        method: 'post',
        data: data
    })
}

//政策指南 详情
export function getGuideDetail(data = {}) { 
    return request({
        url: '/api/v1/news_policy/news_policy_detail',
        method: 'post',
        data: data
    })
}